'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LaunchDarkly = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _ldclientJs = require('ldclient-js');

var _ldclientJs2 = _interopRequireDefault(_ldclientJs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var LaunchDarkly = function () {
  function LaunchDarkly() {
    _classCallCheck(this, LaunchDarkly);
  }

  _createClass(LaunchDarkly, null, [{
    key: 'initialize',
    value: function initialize(_ref) {
      var client_id = _ref.client_id,
          user = _ref.user,
          flags = _ref.flags;
      this.ldclient = _ldclientJs2.default.initialize(client_id, user, {
        bootstrap: flags
      });
    }
    /**
     * @param  {String} flag   The feature flag id
     * @param  {Boolean} def The default value of the feature flag in case LaunchDarkly is unreachable
     * @return {Boolean} The value of the feature flag
     */

  }, {
    key: 'flag',
    value: function flag(_flag) {
      var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.ldclient.variation(_flag, def);
    }
    /**
     * Returns all the feature flags.
     *
     * @return {Object<String, Boolean>}
     */

  }, {
    key: 'allFlags',
    value: function allFlags() {
      return this.ldclient.allFlags();
    }
  }]);

  return LaunchDarkly;
}();

exports.LaunchDarkly = LaunchDarkly;